import Vue from 'vue'
import Router from 'vue-router'
import BudgetTasks from './views/budget/Tasks.vue'
import BudgetBudget from './views/budget/Budget.vue'
import BudgetGraph from './views/budget/Graph.vue'
import BudgetAnalytics from './views/budget/Analytics.vue'
import PerformanceTasks from './views/performance/Tasks.vue'
import PerformanceContracts from './views/performance/Contracts.vue'
import PerformancePowerHours from './views/performance/PowerHours.vue'
import PerformanceProductivity from './views/performance/Productivity.vue'
import PerformanceWorkforce from './views/performance/Workforce.vue'
import CostTasks from './views/cost/Tasks.vue'
import Settings from './views/settings/Settings.vue'
import Login from './components/users/Login.vue'
import Profile from './views/Profile.vue'
import ForgotPassword from './components/users/ForgotPassword.vue'
import ResetPassword from './components/users/ResetPassword.vue'
import Magazine from './views/Magazine.vue'
import HoursSplit from './views/cost/HoursSplit'
import CostAnalytics from './views/cost/Analytics'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        { path: '/', redirect: { name: 'budget-tasks' } },
        {
            path: '/user/login',
            name: 'user-login',
            component: Login
        },
        {
            path: '/user/forgot-password',
            name: 'user-forgot-password',
            component: ForgotPassword
        },
        {
            path: '/settings/invite-user',
            name: 'user-invite',
            component: Settings
        },
        {
            path: '/user/reset-password',
            name: 'user-reset-password',
            component: ResetPassword
        },
        {
            path: '/user/profile',
            name: 'user-profile',
            component: Profile
        },
        {
            path: '/budget/tasks',
            name: 'budget-tasks',
            component: BudgetTasks
        },
        {
            path: '/budget/budget',
            name: 'budget-budget',
            component: BudgetBudget,
            props: true
        },
        {
            path: '/budget/graph',
            name: 'budget-graph',
            component: BudgetGraph
        },
        {
            path: '/budget/analytics',
            name: 'budget-analytics',
            component: BudgetAnalytics
        },
        {
            path: '/performance/tasks',
            name: 'performance-tasks',
            component: PerformanceTasks
        },
        {
            path: '/performance/workforce',
            name: 'performance-workforce',
            component: PerformanceWorkforce
        },
        {
            path: '/performance/contracts',
            name: 'performance-contracts',
            component: PerformanceContracts
        },
        {
            path: '/performance/productivity',
            name: 'performance-productivity',
            component: PerformanceProductivity
        },
        {
            path: '/performance/powerhours',
            name: 'performance-powerhours',
            component: PerformancePowerHours
        },
        {
            path: '/cost/tasks',
            name: 'cost-tasks',
            component: CostTasks
        },
        {
            path: '/settings/interests',
            name: 'settings-interests',
            component: Settings
        },
        {
            path: '/settings/cycles',
            name: 'settings-cycles',
            component: Settings
        },
        {
            path: '/settings/stores',
            name: 'settings-stores',
            component: Settings
        },
        {
            path: '/settings/store-detail',
            name: 'settings-store-detail',
            component: Settings
        },
        {
            path: '/settings/add-store',
            name: 'settings-store-add',
            component: Settings
        },
        {
            path: '/settings/exports',
            name: 'settings-exports',
            component: Settings
        },
        {
            path: '/settings/data',
            name: 'settings-data',
            component: Settings
        },
        {
            path: '/settings/users',
            name: 'settings-users',
            component: Settings
        },
        {
            path: '/settings/user-detail',
            name: 'settings-user-detail',
            component: Settings
        },
        {
            path: '/settings/overview',
            name: 'settings-overview',
            component: Settings
        },
        {
            path: '/settings/playground',
            name: 'settings-playground',
            component: Settings
        },
        {
            path: '/magazine',
            name: 'magazine',
            component: Magazine
        },
        {
            path: '/cost/hours-split',
            name: 'cost-hours-split',
            component: HoursSplit
        },
        {
            path: '/cost/analytics',
            name: 'cost-analytics',
            component: CostAnalytics
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.path === '/user/login' || to.path === '/user/reset-password' || to.path === '/user/forgot-password' || to.path === '/magazine') {
        next()
    } else if (!localStorage.getItem('refresh_token')) {
        return next({
            path: '/user/login',
            query: { redirect: to.fullPath }
        })
    } else {
        next()
    }
})

export default router
